import { apiInstance } from './_base'

//
//

const BASE_URL = '/mini-app'

//
//

export const getLoginInfo = async () => {
  const res = await apiInstance.get(`${BASE_URL}/auth`, null, {
    notThrowUnauthorized: true,
  })

  return res
}

export const sendContactFeedback = async (data) => {
  const res = await apiInstance.post(`${BASE_URL}/contact-feedback`, { data })

  return res
}
